import {createSlice} from '@reduxjs/toolkit';
import _ from 'lodash';
import API from '../../app/api';
import {setSnackbar} from './globals';
import {
    DEFAULT_ASSESSMENTS_VALUE,
    DEFAULT_LEVEL_VALUE_CLEANING_REQUEST,
    DEFAULT_LOCATION_VALUE_CLEANING_REQUEST,
    DEFAULT_OBS_CFG_VALUE,
    DEFAULT_PATIENT_VALUE,
    DEFAULT_REGISTRATION_VALUE,
    DEFAULT_TRIGGER_VALUE_CLEANING_REQUEST,
} from '../../pages/admin/aglyeConfig/configDefaultValues';

export const externalConfig = createSlice({
    name: 'externalConfig',
    initialState: {
        loading: undefined,
        configs: [],
        cleaningRequestCfg: {
            levels: DEFAULT_LEVEL_VALUE_CLEANING_REQUEST,
            location: DEFAULT_LOCATION_VALUE_CLEANING_REQUEST,
            triggers: DEFAULT_TRIGGER_VALUE_CLEANING_REQUEST,
            wards: [],
        },
        registrationCfg: DEFAULT_REGISTRATION_VALUE,
        patientCfg: DEFAULT_PATIENT_VALUE,
        observationCfg: DEFAULT_OBS_CFG_VALUE,
        assessmentCfg: DEFAULT_ASSESSMENTS_VALUE,
    },
    reducers: {
        setConfig: (state, data) => {
            state.configs = data.payload;
        },
        setLoading: (state, data) => {
            state.loading = data.payload;
        },
        setCleaningRequestCfg: (state, data) => {
            state.cleaningRequestCfg = data.payload;
        },
        setRegistrationCfg: (state, data) => {
            state.registrationCfg = data.payload;
        },
        setPatientCfg: (state, data) => {
            state.patientCfg = data.payload;
        },
        setObservationCfg: (state, data) => {
            state.observationCfg = data.payload;
        },
        setAssessmentCfg: (state, data) => {
            state.assessmentCfg = data.payload;
        },
    },
});

// Setters
export const {
    setConfig,
    setLoading,
    setCleaningRequestCfg,
    setRegistrationCfg,
    setPatientCfg,
    setObservationCfg,
    setAssessmentCfg,
} = externalConfig.actions;

// Variable
export const externalConfigs = state => state.externalConfig.configs;
export const cleaningRequestConfigs = state => state.externalConfig.cleaningRequestCfg;
export const registrationConfig = state => state.externalConfig.registrationCfg;
export const patientConfig = state => state.externalConfig.patientCfg;
export const observationConfig = state => state.externalConfig.observationCfg;
export const assessmentsConfig = state => state.externalConfig.assessmentCfg;

// Methods
export const loadExternalConfigs = () => (dispatch, getState) => {
    if (getState().externalConfig.loading !== true) {
        dispatch(setLoading(true));

        API.getExternalConfig()
            .then((res) => {
                if (!_.isEmpty(res?.__data)) {
                    dispatch(setConfig(_.filter(res?.__data, cfg => cfg.active)));
                    const cfgCR = _.find(res.__data, {configType: 'bed.cleaning.request'});
                    const cfgReg = _.find(res.__data, {configType: 'registration'});
                    const cfgPt = _.find(res.__data, {configType: 'patients'});
                    const cfgObs = _.find(res.__data, {configType: 'observations'});
                    const cfgAss = _.find(res.__data, {configType: 'assessments'});
                    if (cfgCR) dispatch(getCleaningRequestConfig(cfgCR));
                    if (cfgReg) dispatch(setRegistrationCfg(cfgReg.value));
                    if (cfgPt) dispatch(setPatientCfg(cfgPt.value));
                    if (cfgObs) dispatch(setObservationCfg(cfgObs.value));
                    if (cfgAss) dispatch(setAssessmentCfg(cfgAss.value));
                }
            })
            .catch((err) => {
                console.error(err);
                dispatch(setSnackbar({
                    type: 'error',
                    message: 'Unable to load external configuration. Please reload the application.',
                }));
            })
            .finally(() => {
                dispatch(setLoading(undefined));
            });
    }
};

export const getExternalConfigs = (type) => (dispatch, getState) => {
    if (getState().externalConfig.loading !== true) {
        return _.find(getState().externalConfig.configs, cfg => cfg.configType === type) || null;
    }
};

export const saveExternalConfigs = (data) => (dispatch, getState) => {
    if (getState().externalConfig.loading !== true) {
        API.saveExternalConfig(data)
            .then((res) => {
                dispatch(loadExternalConfigs());
                dispatch(setSnackbar({
                    type: 'success',
                    message: 'Configuration saved successfully. Please reload the application.',
                }));
            })
            .catch((err) => {
                console.error(err);
                dispatch(setSnackbar({
                    type: 'error',
                    message: 'Unable to save external configuration.',
                }));
            });
    }
};

const getCleaningRequestConfig = (cfg) => (dispatch, getState) => {
    if (cfg) {
        const mergedConfigs = Object.assign({}, getState().externalConfig.cleaningRequestCfg, cfg.value);
        dispatch(setCleaningRequestCfg(mergedConfigs));
    }
};

export default externalConfig.reducer;
